// External globals
import { App } from '@/services/app-compat';
import { api } from '@/services/api-class';
import { Codes } from '@/constants/codes';
import moment from 'moment';
import { AccessAuthorities } from '@/models';
import { hasValue, hasStringValue, getModuleType, currentUserHasPermission } from '@/utils/legacy-utils';

import { ModuleType } from '@/constants/codes';
import { hasNumericValue } from '@/utils/validation';
import { CallCardStatus } from '@/services/api-types';
import { load } from '@/services/loading';
import { isUWPApp, isIOSApp, isAndroidApp, isWindowsAppSdkApp, kstConfirm, kstPrompt, CallCard, Mousetrap, $ } from '@/utils/window-globals';

export let newCallCard = false;
export let _isCallCardScreenLoaded: boolean = false;
export let _isCallCardRealtimeEnabled: boolean = false;
export let callCardClockRefreshInterval: any = null;

export function CAD_Home() {
    (window as any).initHomeScreen('Dispatch Module', 'Dispatch', (window as any).HelpDeskType.CADGettingStarted);
}

export function CAD_Selected() {
    CAD_Home();
}

export function CAD_OfficerStatus() {
    (window as any).setUpOfficerStatusScreen('cad');
}

export function CAD_CallCard(id: number, lat = null, lng = null, callLocFormattedAddress = null) {
    (window as any).resetCallCardClockRefresh();

    newCallCard = false;

    if (hasNumericValue(id) && id > 0) {
        subscribeToCallCardUpdates(id, ModuleType.cad);
    }

    api.getAvailableCADOfficers(id, availableOfficersResult => {
        (window as any).processCallCardAvailableOfficers(availableOfficersResult);

        if (hasNumericValue(id) && id > 0) {
            api.getCallCardById(id, true, result => {
                App.currentCCOriginal = new CallCard(result, ModuleType.cad, false);
                App.currentCC = new CallCard(result, ModuleType.cad, true, availableOfficersResult.officerList);
                setCallCardScreenLoaded(true);
                setCallCardRealtimeEnabled(true);
            });

            if (hasValue((window as any)._currentCallCardLoadedCallback)) {
                (window as any)._currentCallCardLoadedCallback();
                (window as any)._currentCallCardLoadedCallback = null;
            }
        }
        else {
            newCallCard = true;
            App.currentCCOriginal = new CallCard(undefined, ModuleType.cad, false);
            App.currentCC = new CallCard(undefined, ModuleType.cad, true);

            if (callLocFormattedAddress) {
                //Base 64 decode location since encodeURIComponent() appears to get decoded by the router. This makes it a problem for call locations with "|" in the name.
                App.currentCC.callLocFormattedAddress = atob(callLocFormattedAddress);
            } else if (hasValue(lat) && hasValue(lng)) {
                App.currentCC.callLocFormattedAddress = lat + "," + lng;
            }

            setCallCardScreenLoaded(true);
            setCallCardRealtimeEnabled(true);

            if (hasValue((window as any)._currentCallCardLoadedCallback)) {
                (window as any)._currentCallCardLoadedCallback();
                (window as any)._currentCallCardLoadedCallback = null;
            }
        }
    });
}

export function subscribeToCallCardUpdates(id: number, moduleType: ModuleType) {
    App.currentCCSubscribedId = id;
}

export function cleanUpCallCard() {
    setCallCardScreenLoaded(false);
    setCallCardRealtimeEnabled(false);

    App.currentCCSubscribedId = null;
    App.currentCC = null;
    App.currentCCOriginal = null;
    App.currentCCCntr = null;
    App.callCardController = null;
    App.currentCCSubscribedId = null;

    if ((window as any).realtimeUpdateCallCardScreenLoadedTimeout !== null) {
        clearTimeout((window as any).realtimeUpdateCallCardScreenLoadedTimeout);
        (window as any).realtimeUpdateCallCardScreenLoadedTimeout = null;
    }
}

export function setCallCardScreenLoaded(isLoaded: boolean) {
    if (isLoaded) {
        setTimeout(() => {
            _isCallCardScreenLoaded = true;
        }, 0);
    } else {
        _isCallCardScreenLoaded = false;
    }
}

export function setCallCardRealtimeEnabled(isEnabled: boolean) {
    if (isEnabled) {
        setTimeout(() => {
            _isCallCardRealtimeEnabled = true;
        }, 0);
    } else {
        _isCallCardRealtimeEnabled = false;
    }
}

export function isCallCardScreenLoaded() {
    return _isCallCardScreenLoaded;
}

export function isCallCardRealtimeEnabled() {
    return _isCallCardRealtimeEnabled;
}



// Window registrations
(window as any).CAD_Home = CAD_Home;
(window as any).CAD_Selected = CAD_Selected;
(window as any).CAD_OfficerStatus = CAD_OfficerStatus;
(window as any).CAD_CallCard = CAD_CallCard;
(window as any).subscribeToCallCardUpdates = subscribeToCallCardUpdates;
(window as any).cleanUpCallCard = cleanUpCallCard;
(window as any).setCallCardScreenLoaded = setCallCardScreenLoaded;
(window as any).setCallCardRealtimeEnabled = setCallCardRealtimeEnabled;
(window as any).isCallCardScreenLoaded = isCallCardScreenLoaded;
(window as any).isCallCardRealtimeEnabled = isCallCardRealtimeEnabled;
(window as any).newCallCard = newCallCard;
